<template>
  <div class="page-footer d-flex align-items-center justify-content-end w-100 bg-white px-3 py-3 mb-3">
    <span class="add-piece-cta mr-auto" @click="addPrice">
      <img src="@/assets/img/add-client-icon.svg" alt="" class="mr-2" />
      Add new price
    </span>
    <b-alert
      v-if="isFinishedStatus"
      :model-value="true"
      variant="secondary"
      class="alert-info-danger d-flex align-items-center mr-3 mb-0"
    >
      <span><b>Important: </b>You cannot change prices level for this assignment</span>
    </b-alert>
    <b-alert v-else :model-value="true" variant="secondary" class="popup-info d-inline-block mr-3">
      <mdicon name="InformationOutline" class="mr-1" />
      Changes will be made in the next assignment
    </b-alert>
    <b-button
      variant="success"
      size="lg"
      class="btn-green btn-save"
      :disabled="isDisabled || isFinishedStatus"
      @click="savePrices"
    >
      Save
    </b-button>
  </div>
</template>

<script lang="ts">
import type { BasePrice } from '@/types/Models/BasePrice'
import { BAlert, BButton } from 'bootstrap-vue-next'
import { storeToRefs } from 'pinia'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { usePricesStore } from '@/store/prices'

export default defineComponent({
  name: 'PageFooter',
  components: { BButton, BAlert },
  emits: ['save-prices', 'add-price'],
  setup(_, { emit }) {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const pricesStore = usePricesStore()
    const { isFinishedStatus } = storeToRefs(assignmentSummaryStore)

    const changedPrices: ComputedRef<BasePrice[]> = computed(() => pricesStore.changedPrices)
    const isDisabled: ComputedRef<boolean> = computed(() => changedPrices.value.length === 0)

    const savePrices = () => {
      emit('save-prices')
    }

    const addPrice = () => {
      emit('add-price')
    }

    return {
      isDisabled,
      isFinishedStatus,
      savePrices,
      addPrice,
    }
  },
})
</script>
